import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { styles } from "./styles";
import TwoValuePieCard from "../../../../Component/Cards/TwoValuePieCard";
import SingleValueCard from "../../../../Component/Cards/SingleValueCard";
import { BrandColors } from "../../../../styles/BrandColors";
import { useTranslation } from "react-i18next";

const PageHeader = (props) => {
  const { classes, totals = {} } = props;
  const { t } = useTranslation();
  return (
    <div className={classes.pageHeaderContainer}>
      <Grid container spacing={0}>
        <Grid item xs={9}>
          <Grid container justify="space-between">
            <Grid item xs={4}>
              <TwoValuePieCard
                value1={totals.amlExpringCount}
                value2={totals.kycExpringCount}
                hideChart={true}
                totalLabel={t("labels.records.dashboard.expiringIn360Days")}
              />
            </Grid>
            <Grid item xs={4}>
              <SingleValueCard
                label={t("labels.records.dashboard.newInLast30Days")}
                valueColor={BrandColors.JLLBrandColors.Green.tint75Percent}
                value={totals.newCount}
              />
            </Grid>
            <Grid item xs={4}>
              <SingleValueCard
                value={totals.blockedCount}
                valueColor={BrandColors.JLLBrandColors.Black.core}
                label={t("labels.records.dashboard.blocked")}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container justify="flex-end" alignItems="flex-end"></Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PageHeader);
